var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { keyframes } from 'styled-components';
import EmptyAvatar from '../svgs/EmptyAvatar';
import { Flex } from 'pcln-design-system';
import { motion } from 'framer-motion';
var createAudioWaveAnimation = function (minHeight, maxHeight) {
  return keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%, 100% {\n    height: ", "px;\n  }\n  50% {\n    height: ", "px;\n  }\n"], ["\n  0%, 100% {\n    height: ", "px;\n  }\n  50% {\n    height: ", "px;\n  }\n"])), minHeight, maxHeight);
};
var AudioBarContainer = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "AudioWaveAnimation__AudioBarContainer",
  componentId: "sc-18uu3vq-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex; /* Center the SVG */\n  justify-content: center;\n  align-items: center;\n  width: 34px; /* Width including the border */\n  height: 34px; /* Height including the border */\n  background-color: white; /* Background for the border */\n  border-radius: 50%; /* Makes it circular */\n  z-index: 1000;\n  position: relative;\n  margin-top: -16px;\n  top: 8px;\n  box-sizing: border-box;\n  svg {\n    width: 32px; /* Your SVG's width */\n    height: 32px; /* Your SVG's height */\n  }\n"], ["\n  display: inline-flex; /* Center the SVG */\n  justify-content: center;\n  align-items: center;\n  width: 34px; /* Width including the border */\n  height: 34px; /* Height including the border */\n  background-color: white; /* Background for the border */\n  border-radius: 50%; /* Makes it circular */\n  z-index: 1000;\n  position: relative;\n  margin-top: -16px;\n  top: 8px;\n  box-sizing: border-box;\n  svg {\n    width: 32px; /* Your SVG's width */\n    height: 32px; /* Your SVG's height */\n  }\n"])));
function getRandomBetween(min, max) {
  return Math.random() * (max - min) + min;
}
var Bar = /*#__PURE__*/styled.div.withConfig({
  displayName: "AudioWaveAnimation__Bar",
  componentId: "sc-18uu3vq-1"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: white;\n  width: 1.37px !important;\n  height: 5px;\n  border-radius: 0;\n  margin: 0 0.5px;\n  animation: ", "\n    ", "s ease-in-out infinite;\n"], ["\n  background-color: white;\n  width: 1.37px !important;\n  height: 5px;\n  border-radius: 0;\n  margin: 0 0.5px;\n  animation: ", "\n    ", "s ease-in-out infinite;\n"])), function (_a) {
  var minHeight = _a.minHeight,
    maxHeight = _a.maxHeight;
  return createAudioWaveAnimation(minHeight, maxHeight);
}, function (_a) {
  var animationDuration = _a.animationDuration;
  return animationDuration;
});
var BarWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "AudioWaveAnimation__BarWrapper",
  componentId: "sc-18uu3vq-2"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  justify-content: center;\n  align-items: center;\n"])));
var AudioWaveAnimation = function () {
  return React.createElement(AudioBarContainer, {
    initial: {
      opacity: 1
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 1
    }
  }, React.createElement(EmptyAvatar, null), React.createElement(BarWrapper, null, React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 2,
    maxHeight: 5
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 5,
    maxHeight: 7
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 7,
    maxHeight: 10
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 10,
    maxHeight: 12
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 12,
    maxHeight: 15
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 10,
    maxHeight: 12
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 7,
    maxHeight: 10
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 5,
    maxHeight: 7
  }), React.createElement(Bar, {
    delay: Math.random(),
    animationDuration: getRandomBetween(0.3, 1),
    minHeight: 2,
    maxHeight: 5
  })));
};
export default AudioWaveAnimation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;